import { useRecordContext } from 'react-admin'
import { Typography, Tooltip } from '@mui/material'
import Pill from './pill'

const TextFieldWithTooltip = ({
  record: PropertyRecord,
  source,
  maxLength = 5,
  minWidth = '100%',
  width = '100%',
  renderAsPill,
  maxLines = 1,
  sx,
  getValue,
}) => {
  const record = PropertyRecord || useRecordContext()
  if (!record || record[source] === null || record[source] === undefined)
    return null

  const shortenString = record[source].substring(0, maxLength)
  const ellipsis = shortenString === record[source] ? '' : '...'
  const value = getValue
    ? getValue(record, shortenString + ellipsis)
    : shortenString + ellipsis

  const styles = {
    width: width,
    minWidth: minWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    ...(width !== '100%' && maxLines === 1
      ? {
          display: 'block',
          whiteSpace: 'nowrap',
        }
      : {
          display: '-webkit-box',
          WebkitLineClamp: maxLines,
          WebkitBoxOrient: 'vertical',
        }),
  }

  return (
    <Tooltip title={record[source]}>
      {renderAsPill ? (
        <Pill status="info" value={value} sx={sx} />
      ) : (
        <Typography sx={{ ...styles, ...sx }} variant="body2">
          {value}
        </Typography>
      )}
    </Tooltip>
  )
}

export default TextFieldWithTooltip
